module.exports = __webpack_public_path__ + "img/golog_admin.73b31bd9.png";